module.exports = __webpack_public_path__ + "static/media/powered_normal_moblyx_no_strapline_blue_circle.899fefd3.png";